import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { CatalogData, CatalogKey } from "@/Services/CatalogStorage";
import { getCatalogProductsThunk } from "@/store/slices/catalog/catalog.slice.thunks";

interface CatalogState {
    data: Partial<CatalogData>;
    loading: Partial<Record<CatalogKey, boolean>>;
}

const initialState: CatalogState = {
    data: {},
    loading: {},
};

const catalogSlice = createSlice({
    name: "catalog",
    initialState,
    reducers: {
        setCatalog(
            state,
            action: PayloadAction<{
                key: CatalogKey;
                data: CatalogData[CatalogKey];
            }>,
        ) {
            state.data[action.payload.key] = action.payload.data;
        },
        setCatalogLoading(
            state,
            action: PayloadAction<{ key: CatalogKey; value: boolean }>,
        ) {
            state.loading[action.payload.key] = action.payload.value;
        },
    },
    extraReducers: (builder) => {
        builder.addCase(
            getCatalogProductsThunk.fulfilled,
            (state, { payload }) => {
                state.data[CatalogKey.Products] = payload;
            },
        );
    },
});

export const { setCatalog, setCatalogLoading } = catalogSlice.actions;

export const catalogReducer = catalogSlice.reducer;
